/* eslint-disable comma-dangle */
/* eslint-disable quotes */
const routes = [
  {
    index: true,
    label: "Abhishek Chakravarty",
    path: "/"
  },
  {
    label: "Resume",
    path: "/resume"
  },
  {
    label: "Projects",
    path: "/projects"
  },
  {
    label: "Contact",
    path: "/contact"
  }
  // {
  //   label: 'About',
  //   path: '/about',
  // },
  // {
  //   label: 'Stats',
  //   path: '/stats',
  // },
];

export default routes;
